var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6000",
    "data-name": "Group 6000",
    transform: "translate(-716 -675)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(716 675)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Macroeconomics_1_",
    transform: "translate(731.559 690.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    d: "M216.448,184.067a2.241,2.241,0,1,0,1.793-3.585,2.241,2.241,0,1,1,1.793-3.585",
    transform: "translate(-205.02 -167.261)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    y1: 2.335,
    transform: "translate(13.339 6.455)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    y2: 2.335,
    transform: "translate(13.339 17.662)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7131",
    "data-name": "Path 7131",
    d: "M33.22,46.441a2.774,2.774,0,0,1-2.447-1.5,3.629,3.629,0,0,0-1.743-1.577l-.043-.019h-.026a3.528,3.528,0,0,0-1.293-.244,3.717,3.717,0,0,0-1.007.141,2.817,2.817,0,0,1-.83.126,2.744,2.744,0,0,1-1.953-.808,2.811,2.811,0,0,1-.683-2.782,3.588,3.588,0,0,0-.1-2.3v-.026l-.019-.043A3.625,3.625,0,0,0,21.5,35.668a2.749,2.749,0,0,1,0-4.9,3.627,3.627,0,0,0,1.577-1.743l.019-.043V28.98a.291.291,0,0,0,.016-.048A3.606,3.606,0,0,0,23.2,26.66a2.753,2.753,0,0,1,2.638-3.583,2.95,2.95,0,0,1,.826.119,3.724,3.724,0,0,0,1.009.141,3.528,3.528,0,0,0,1.293-.244h.026l.043-.019A3.627,3.627,0,0,0,30.773,21.5a2.749,2.749,0,0,1,4.9,0,3.628,3.628,0,0,0,1.743,1.577l.043.019h.026a3.528,3.528,0,0,0,1.293.244,3.721,3.721,0,0,0,1.007-.141,2.817,2.817,0,0,1,.83-.126,2.744,2.744,0,0,1,1.953.808,2.811,2.811,0,0,1,.683,2.781,3.588,3.588,0,0,0,.1,2.3v.026l.019.043a3.627,3.627,0,0,0,1.576,1.742,2.749,2.749,0,0,1,0,4.9,3.626,3.626,0,0,0-1.577,1.743l-.019.043v.026a3.587,3.587,0,0,0-.1,2.3,2.773,2.773,0,0,1-.682,2.783,2.743,2.743,0,0,1-1.955.8,2.95,2.95,0,0,1-.826-.119,3.722,3.722,0,0,0-1.009-.141,3.528,3.528,0,0,0-1.293.244h-.026l-.043.019a3.627,3.627,0,0,0-1.742,1.576A2.774,2.774,0,0,1,33.22,46.441Z",
    transform: "translate(-20 -20)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryFee);
export default __webpack_public_path__ + "static/media/DeliveryFee.aa56bb911fa913f12c5beed0127de46e.svg";
export { ForwardRef as ReactComponent };